import './index.scss';
import React from 'react';

const MainAdminPage = () => {
  return (
    <div className="MainAdminPage_wrapper">
      ADMIN PAGE
    </div>
  );
};

export default MainAdminPage;
